import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import FIELDS from '../../data/fields';
import {
  updateProductFeedbackReason, createProductFeedbackReason,
} from '../../app/store/actions/productFeedbackReason';


class ProductFeedbackReasonFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      productFeedbackReasonId: null,
      isLoading: false,
      editRecord: false,
      messageErro: '',
      messageSuccess: '',
    };
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  goBack = () => {
    this.props.back.goBack();
  };

  createProductFeedbackReason = async () => {
    this.setState({ isLoading: true });
    try {
      await this.props.createProductFeedbackReason({ reason: this.state.reason });
      await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: '' });

      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;
        this.setState({ messageErro: messageError });
      } else {
        this.setState({ messageErro: I18n.t('errorOcurred') });
      }
    }
    this.setState({ isLoading: false });
  }

  updateProductFeedbackReason = async () => {
    this.setState({ isLoading: true });
    const { productFeedbackReasonId, reason } = this.state;
    try {
      await this.props.updateProductFeedbackReason({ productFeedbackReasonId, reason });
      await this.setState({ messageSuccess: I18n.t('changeMade') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: '' });

      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageErro: messageError });
      } else {
        this.setState({ messageErro: I18n.t('errorOcurred') });
      }
    }
    this.setState({ isLoading: false });
  }

  componentDidMount = async () => {
    if (this.props.back.location.selectedProductFeedbackReason) {
      this.setState({
        editRecord: true,
        reason: this.props.back.location.selectedProductFeedbackReason.reason,
        productFeedbackReasonId: this.props.back.location.selectedProductFeedbackReason.id,
      });
    }
  }

  render() {
    const {
      reason, messageSuccess, isLoading, editRecord,
      messageErro,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {(!editRecord) ? I18n.t('registerProductFeedbackReason') : I18n.t('editProductFeedbackReason')}
        </h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('reason')}
            </p>
            <input
              type="text"
              placeholder=""
              value={reason}
              maxLength={FIELDS.productFeedbackReason.maxLength}
              className="form-control"
              onChange={e => this.setValue('reason', e.target.value)}
            />
          </div>

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageErro && <p className="color-red margin-top-10">{messageErro}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => ((!editRecord)
                ? this.createProductFeedbackReason()
                : this.updateProductFeedbackReason()
              )}
              disabled={isLoading}
            >
              {(!editRecord) ? I18n.t('save') : I18n.t('update')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateProductFeedbackReason: productFeedbackReasonParameter => dispatch(
    updateProductFeedbackReason(productFeedbackReasonParameter),
  ),
  createProductFeedbackReason: newProductFeedbackReason => dispatch(
    createProductFeedbackReason(newProductFeedbackReason),
  ),
});

const mapStateToProps = () => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(ProductFeedbackReasonFormComponent);
